@import './variables.scss';
$dropdown-body-height: calc(100vh - $navbar-height - $navbar-top-height - $mobile-padding);
$dropdown-body-width: calc(100vw - 2*$mobile-padding);
$dropdown-top-position: 60px;
$breakpoint-s-padding: 40px;
$breakpoint-s-dropdown-body-width: calc(100vw - 2*$breakpoint-s-padding);


zpr-dropdown.nav-mobile-dropdown {
    min-width: $dropdown-body-width;
    min-height: $dropdown-body-height;

    a {
        color: $text-color;
    }

    li {
        &::before {
            display: none;
        }
    }


    &[size="default"] {
        [slot="body"] {
            padding: 24px;
            min-height: $dropdown-body-height;
            padding-top: 0;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
    }

    zpr-accordion-panel.link-header {
        span.arrow {
            display: none;
        }

        a.btn {
            font-weight: 700;
            font-size: 16px;
        }
    }

    zpr-accordion {
        background-color: transparent;

        zpr-accordion-panel {
            .accordion-heading .accordion-header h3 {
                font-size: 16px;
            }

            .accordion-content ul {
                padding: 0;

                li {
                    padding: 0;
                    margin-bottom: 24px;

                    &.title {
                        font-size: 16px;
                        font-weight: 700;
                    }

                    &:last-child {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
    .submenu-header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        svg {
            margin-right: 12px;
        }

        p {
            margin-bottom: 0;
        }

        p.title {
            margin-bottom: 8px;
        }

        .arrow {
            transform: rotate(270deg);
        }

        .back-button {
            display: none;
        }

        .open-button {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;

            &:hover {
                p {
                    color: $hover-color;
                }

                svg path {
                    fill: $hover-color;
                }

                .arrow {
                    mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 12 8' xmlns='http://www.w3.org/2000/svg' stroke='%23073158'%3E%3Cpath d='M1 1l5.07130435 5.29043478L11 1' stroke-width='1.5' fill='none' fill-rule='evenodd' stroke-linecap='round'/%3E%3C/svg%3E");
                    -webkit-mask-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 12 8' xmlns='http://www.w3.org/2000/svg' stroke='%23073158'%3E%3Cpath d='M1 1l5.07130435 5.29043478L11 1' stroke-width='1.5' fill='none' fill-rule='evenodd' stroke-linecap='round'/%3E%3C/svg%3E");
                    background-image: none;
                    background-color: $hover-color;
                }
            }
        }
    }

    zpr-accordion zpr-accordion-panel {

        .accordion-heading .accordion-header p.title,
        .accordion-content p.title {
            font-size: 16px;
            font-weight: 700;
        }

        .accordion-content .accordion-body {
            padding-right: 0;
        }

        .accordion-heading:has(+ .accordion-open) {
            p {
                color: $hover-color;
            }
        }

        .arrow-up {
            background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 12 8' xmlns='http://www.w3.org/2000/svg' stroke='%234A90E2'%3E%3Cpath d='M1 1l5.07130435 5.29043478L11 1' stroke-width='1.5' fill='none' fill-rule='evenodd' stroke-linecap='round'/%3E%3C/svg%3E");
        }
    }

    .submenu-list {
        display: none;
    }

    // Styles for submenu opened
    zpr-accordion {
        position: relative;
    }

    .submenu-dropdown.active {
        // position: initial;
        position: absolute;
        top: 0;
        left: 0;
        padding-top: $mobile-padding;
        width: 100%;
        height: 100%;
        background-color: white;
        z-index: 100;

        .submenu-list {
            display: block;
            width: 100%;
        }

        .submenu-header {
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            width: 100%;
            height: 100%;

            p {
                color: $hover-color;

                &.title {
                    margin: 12px 0;

                    &+p {
                        display: none;
                    }
                }
            }

            svg,
            .arrow {
                display: none;
            }

            .back-button {
                display: flex;
                margin-bottom: $mobile-padding;

                &:hover .arrow-back {
                    background-color: $hover-color;
                }
            }

            .arrow-back {
                width: 20px;
                height: 20px;
                margin-right: 10px;
                -webkit-mask-image: url('data:image/svg+xml,<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Arrow 20x20"><path id="Vector" d="M11.9114 5.28431L11.8536 5.35355L7.207 10L11.8536 14.6464C12.0488 14.8417 12.0488 15.1583 11.8536 15.3536C11.68 15.5271 11.4106 15.5464 11.2157 15.4114L11.1464 15.3536L6.14645 10.3536C6.08136 10.2885 6.03797 10.2099 6.01627 10.1268L6.00181 10.0426L6.00181 9.95739C6.00904 9.87233 6.03797 9.78877 6.08859 9.71569L6.14645 9.64645L11.1464 4.64645C11.3417 4.45118 11.6583 4.45118 11.8536 4.64645C12.0054 4.79832 12.0392 5.02358 11.9548 5.20807L11.9114 5.28431Z" fill="%23073158"/></g></svg>');
                mask-image: url('data:image/svg+xml,<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="Arrow 20x20"><path id="Vector" d="M11.9114 5.28431L11.8536 5.35355L7.207 10L11.8536 14.6464C12.0488 14.8417 12.0488 15.1583 11.8536 15.3536C11.68 15.5271 11.4106 15.5464 11.2157 15.4114L11.1464 15.3536L6.14645 10.3536C6.08136 10.2885 6.03797 10.2099 6.01627 10.1268L6.00181 10.0426L6.00181 9.95739C6.00904 9.87233 6.03797 9.78877 6.08859 9.71569L6.14645 9.64645L11.1464 4.64645C11.3417 4.45118 11.6583 4.45118 11.8536 4.64645C12.0054 4.79832 12.0392 5.02358 11.9548 5.20807L11.9114 5.28431Z" fill="%23073158"/></g></svg>');
                background-color: $text-color;
                display: block;
            }
        }
    }

    zpr-accordion zpr-accordion-panel .accordion-content .submenu-list {
        ul li {
            padding: 24px 0;
            margin: 0;
            border-bottom: 1px solid rgba(0, 0, 0, 0.10);

            &:last-child {
                border-bottom: none;
            }
        }
    }

    @include respond-to($breakpoint-s-min, $breakpoint-s-max) {
        zpr-dropdown[size="default"] {
            [slot="body"] {
                width: $breakpoint-s-dropdown-body-width;
            }
        }
    }
}


zpr-navbar-mobile-dropdown {
    .btn.navbar-bottom-icon {
        cursor: pointer;
        padding: 10px 8px;
        display: flex;
        border: none;
        flex-direction: column;
        background: none;
        // justify-content: center;
        align-items: center;
        transition: $navbar-transition-time;
        min-width: 0;

        .navbar-icon-line {
            width: 20px;
            height: 2px;
            margin: 0 0 5px 0;
            background: color('midnight');
            transition: $navbar-transition-time;

            &:nth-child(2) {
                width: 28px;
            }
        }

        &:hover {
            background: none;
        }
    }

    &[open] .navbar-bottom-icon {
        transform: rotate(180deg);

        .navbar-icon-line {
            &:nth-child(1) {
                transform: rotate(45deg) translate(5px, 5px);
            }

            &:nth-child(2) {
                opacity: 0;
            }

            &:nth-child(3) {
                transform: rotate(-45deg) translate(5px, -5px);
            }
        }
    }
}